

export const apiRoot = 'co0qkcxee9';
export const environment = 'dev';
export const mainUrl = `https://${apiRoot}.execute-api.sa-east-1.amazonaws.com/${environment}`;

//NOTE(Celso): This is our HUB information
export const authId = "i9hub";
export const authApiRoot = 'j9vp8dgeoe';

//TODO(Celso): Change this to project ID
export const guruId = '30bb0400-f985-11e9-920c-e73ffe2daa80';
